namespace GeniuzPOS.Purchase {
    export interface ReportPurTaxRow {
        Id?: string;
        Lineitemno?: number;
        TaxInvoiceDate?: string;
        TaxInvoiceNo?: string;
        SupplName?: string;
        SupplTaxId?: string;
        NetAmt?: number;
        VatAmt?: number;
        TotalAmt?: number;
    }

    export namespace ReportPurTaxRow {
        export const idProperty = 'Id';
        export const nameProperty = 'TaxInvoiceNo';
        export const localTextPrefix = 'Purchase.ReportPurTax';
        export const lookupKey = 'Purchase.ReportPurTax';

        export function getLookup(): Q.Lookup<ReportPurTaxRow> {
            return Q.getLookup<ReportPurTaxRow>('Purchase.ReportPurTax');
        }
        export const deletePermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:View';
        export const insertPermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:View';
        export const readPermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:View';
        export const updatePermission = '5Purchase:ใบขอซื้อ(PR):อนุมัติ:View';

        export declare const enum Fields {
            Id = "Id",
            Lineitemno = "Lineitemno",
            TaxInvoiceDate = "TaxInvoiceDate",
            TaxInvoiceNo = "TaxInvoiceNo",
            SupplName = "SupplName",
            SupplTaxId = "SupplTaxId",
            NetAmt = "NetAmt",
            VatAmt = "VatAmt",
            TotalAmt = "TotalAmt"
        }
    }
}
